import React from 'react';

const NotFound = () => {
  return <div>요청하신 페이지가 없습니다</div>;
};

export default NotFound;
